﻿// src/bootstrap.ts

import $ from "jquery";

// Expose jQuery en global (UMD/Kendo)
declare global {
    interface Window {
        $: typeof $;
        jQuery: typeof $;
    }
}

window.$ = window.jQuery = $;

// Certains UMD attendent l’identifiant global "jQuery"
const jQuery = window.jQuery; // eslint-disable-line @typescript-eslint/no-unused-vars


// Charge ton entry existant
await import("./main");
